import React from 'react';
import { useFormik } from 'formik';
import mainBG from '../../../assets/EinführungMainBG.png';
import ellipseBG from '../../../assets/EllipseBG.png';
import { questionsDetailsSecond } from '../constants/data';
import { useTranslation } from "react-i18next";

const RadioFormSecond = ({ nextClick, backClick, formik }) => {
    const { t } = useTranslation();

    return (
        <div style={{ background: `url(${mainBG})` }} className="h-screen !bg-cover !bg-no-repeat !bg-center flex flex-col justify-between">
            <div></div>
            <div style={{ background: `url(${ellipseBG})` }} className="min-h-[75vh] !bg-cover !bg-no-repeat !bg-top relative">
                <div className="relative h-full mx-auto w-full max-w-[36rem] text-center pb-4 px-6 sm:px-0">
                    <div className="h-full">
                        <form className="flex flex-col justify-between h-full pt-20" onSubmit={formik.handleSubmit}>

                            {/* Form Container */}
                            <div className="w-full max-w-[32rem] sm:max-w-[36rem]">
                                {questionsDetailsSecond.map((question) => (
                                    <div key={question.id} className="py-3 text-left">
                                        <p className="text-white font-medium mb-2">{t(`questionsDetailsSecond.${question?.keyName}`)}</p>

                                        <div className="flex gap-8">
                                            {/* Yes Option */}
                                            <div className="flex items-center gap-2">
                                                <input
                                                    type="radio"
                                                    className="custom-radio my-3"
                                                    id={`${question.id}-ja`}
                                                    value="Ja"
                                                    name={question.id}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    checked={formik.values[question.id] === "Ja"}
                                                />
                                                <label htmlFor={`${question.id}-ja`} className="text-[#F9DCD4] font-normal">
                                                    {t(`yes`)}
                                                </label>
                                            </div>

                                            {/* No Option */}
                                            <div className="flex items-center gap-2">
                                                <input
                                                    type="radio"
                                                    className="custom-radio my-3"
                                                    id={`${question.id}-nein`}
                                                    value="Nein"
                                                    name={question.id}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    checked={formik.values[question.id] === "Nein"}
                                                />
                                                <label htmlFor={`${question.id}-nein`} className="text-[#F9DCD4] font-normal">
                                                    {t(`no`)}
                                                </label>
                                            </div>
                                        </div>

                                        {/* Validation Error */}
                                        {formik.touched[question.id] && formik.errors[question.id] && (
                                            <div className="text-red-500 text-sm mt-1">{formik.errors[question.id]}</div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* Buttons */}
                            <div className="flex gap-6 w-full max-w-[32rem] sm:max-w-[36rem] flex-col-reverse sm:flex-row">
                                <button className="w-full button_primary" onClick={backClick}>{t(`s-2-btn1`)}</button>
                                <button className="w-full button_secodry" onClick={nextClick}>{t(`s-2-btn2`)}</button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RadioFormSecond;
